import * as url from "../images/map_marker.png";

mapboxgl.accessToken =
  "pk.eyJ1IjoieW9ib2lnb3VkYSIsImEiOiJjbDU5c3hzOW8xMmljM3BuczI3aDkxaTVnIn0.wi3N82FZ9zUEE_Eo7wVPpw";

document.querySelectorAll(".map").forEach((mapContainer) => {
  const x = parseFloat(mapContainer.dataset.x);
  const y = parseFloat(mapContainer.dataset.y);
  const map = new mapboxgl.Map({
    container: mapContainer.getAttribute("id"), // container ID
    style: "mapbox://styles/mapbox/outdoors-v11", // style URL
    center: [x, y], // starting position [lng, lat]
    zoom: 16, // starting zoom
  });
  map.resize();
  let markerImage = document.createElement("img");
  markerImage.src = url.default;
  console.log(markerImage);
  const marker = new mapboxgl.Marker({
    element: markerImage,
  })
    .setLngLat([x, y])
    .addTo(map);
});

AOS.init();

modals = document.querySelector(".offers-modals").innerHTML;
document.querySelector(".offers-modals").innerHTML = "";
document.body.innerHTML = document.body.innerHTML + modals;
